import React from 'react';
import { LocationOverviewBinDto } from '../../../../../types/locationOverview';
import { useTranslation } from '../../../../../contexts/I18nProvider';
import { codeValue, DataPanel, DataRow, YesNo } from '../../item-card/sections/DataPanel';
import { formatDate, formatQty } from '../../item-card/format';

interface LocationDataSectionProps {
  bin: LocationOverviewBinDto;
}

/** Lokasjonsdata som produktark (samme paneler som varekortets «Varedata»). Kun visning. */
export const LocationDataSection: React.FC<LocationDataSectionProps> = ({ bin }) => {
  const { t } = useTranslation();
  const prefix = 'warehouse.modules.locationLookup.data';
  const yes = t(`${prefix}.yes`, {}, 'Ja');
  const no = t(`${prefix}.no`, {}, 'Nei');
  const qtyOrNull = (v: number | null) => (v === null || v === undefined ? null : formatQty(v));

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 items-start">
      <DataPanel title={t(`${prefix}.placement`, {}, 'Plassering')}>
        <DataRow label={t(`${prefix}.warehouse`, {}, 'Lager')} value={bin.warehouseID} />
        <DataRow label={t(`${prefix}.zone`, {}, 'Sone')} value={codeValue(bin.stcZoneID, bin.zoneDescription)} />
        <DataRow label={t(`${prefix}.binGroup`, {}, 'Lokasjonsgruppe')} value={codeValue(bin.binGrpNo, bin.binGrpDescription)} />
        <DataRow label={t(`${prefix}.binType`, {}, 'Lokasjonstype')} value={codeValue(bin.binTypeNo, bin.binTypeDescription)} />
        <DataRow label={t(`${prefix}.binSize`, {}, 'Lokasjonsstørrelse')} value={codeValue(bin.binSizeNo, bin.binSizeDescription)} />
        <DataRow label={t(`${prefix}.dedicatedItem`, {}, 'Dedikert vare')} value={bin.dedicatedItemNo} mono />
      </DataPanel>

      <DataPanel title={t(`${prefix}.rules`, {}, 'Regler')}>
        <DataRow label={t(`${prefix}.pickable`, {}, 'Plukkbar')} value={<YesNo value={bin.pickableYesNo} yes={yes} no={no} />} />
        <DataRow label={t(`${prefix}.reservationAllowed`, {}, 'Reserverbar')} value={<YesNo value={bin.reservationAllowed} yes={yes} no={no} />} />
        <DataRow label={t(`${prefix}.shared`, {}, 'Felles lokasjon')} value={<YesNo value={bin.sharedBinYesNo} yes={yes} no={no} />} />
        {bin.sharedBinYesNo && (
          <DataRow label={t(`${prefix}.sharedMax`, {}, 'Maks antall varer (felles)')} value={bin.sharedBinMaxQuantity} />
        )}
        <DataRow
          label={t(`${prefix}.scanRequired`, {}, 'Krev lokasjonsskann')}
          value={bin.barCodeConfirmLocation === null || bin.barCodeConfirmLocation === undefined
            ? t(`${prefix}.inherit`, {}, 'Arv (fra profil)')
            : <YesNo value={bin.barCodeConfirmLocation} yes={yes} no={no} />}
        />
        <DataRow label={t(`${prefix}.replenishMin`, {}, 'Påfylling min')} value={qtyOrNull(bin.replenishMinLevel)} />
        <DataRow label={t(`${prefix}.replenishMax`, {}, 'Påfylling maks')} value={qtyOrNull(bin.replenishMaxLevel)} />
        <DataRow label={t(`${prefix}.lastCounted`, {}, 'Sist telt')} value={bin.lastCountedDate ? formatDate(bin.lastCountedDate) : null} />
        <DataRow label={t(`${prefix}.lastMovement`, {}, 'Sist bevegelse')} value={bin.lastMovementDate ? formatDate(bin.lastMovementDate) : null} />
      </DataPanel>
    </div>
  );
};
